module.exports = __webpack_public_path__ + "img/doorLogo15.64de207b.png";